import { render, staticRenderFns } from "./wechatUserMessageIndex.vue?vue&type=template&id=1840b208&scoped=true"
import script from "./wechatUserMessageIndex.vue?vue&type=script&lang=js"
export * from "./wechatUserMessageIndex.vue?vue&type=script&lang=js"
import style0 from "./wechatUserMessageIndex.vue?vue&type=style&index=0&id=1840b208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840b208",
  null
  
)

export default component.exports